module.exports = __webpack_public_path__ + "static/media/carousel_fr_credibility.ca8c9afd.jpg";